import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function resolveImg(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:") || url.startsWith("blob:")) return url;
  return `${BACKEND_URL}${url}`;
}

// Rewrite remote stock-photo URLs (Unsplash/Pexels) to lighter, sized WebP variants.
export function optimizeRemote(url, width = 1600) {
  if (!url || typeof url !== "string") return url;
  if (url.includes("images.unsplash.com")) {
    const base = url.split("?")[0];
    return `${base}?crop=entropy&cs=srgb&fm=webp&q=60&w=${width}&ixlib=rb-4.1.0`;
  }
  if (url.includes("images.pexels.com")) {
    const base = url.split("?")[0];
    return `${base}?auto=compress&cs=tinysrgb&fm=webp&w=${width}&q=60`;
  }
  return url;
}

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
